import React, { useState, ChangeEvent, FormEvent } from "react";
import { toast } from "react-toastify";
import Button from "../form-components/input/Button";
import { useNavigate } from "react-router-dom";

const UploadDocument = () => {
    const [digitalSealFile, setDigitalSealFile] = useState<File | null>(null);
    const [digitalSealFileType, setDigitalSealFileType] = useState<string>('');
    const [signatureFile, setSignatureFile] = useState<File | null>(null);
    const [signatureFileType, setSignatureFileType] = useState<string>('');
    const [applicationReason, setApplicationReason] = useState<string>('');
    const [isLoading, setIsLoading] = useState(false)
    const applicationId = localStorage.getItem('applicationId')
    const caseId = localStorage.getItem('caseId')
    const authToken = sessionStorage.getItem('token')
    const Navigate = useNavigate()



    const handleDigitalSealUpload = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setDigitalSealFile(file);
            setDigitalSealFileType(file.type);
        }
    };

    const handleSignatureUpload = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setSignatureFile(file);
            setSignatureFileType(file.type);
        }
    };
    const getSignatureUploadUrl = async (contentType: string) => {
        if (!caseId) {
            console.log("case ID is required.");
            return;
        }
        if (!applicationId) {
            console.log("Application ID is required.");
            return;
        }
		const response = await fetch(
			"https://backend-kyw8.onrender.com/court-records/documents/upload-url",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${authToken}`,
				},
				body: JSON.stringify({ caseId, applicationId, contentType, uploadType: 'signature' }),
			}
		);

		const data = await response.json();

		if (!response.ok) {
			throw new Error(data.error ?? "An error occured");
		}

		return data;
	};

    const getDigitalSealUploadUrl = async (contentType: string) => {
        if (!caseId) {
            console.log("case ID is required.");
            return;
        }
        if (!applicationId) {
            console.log("Application ID is required.");
            return;
        }
		const response = await fetch(
			"https://backend-kyw8.onrender.com/court-records/documents/upload-url",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${authToken}`,
				},
				body: JSON.stringify({ caseId, applicationId, contentType, uploadType: 'digital_seal' }),
			}
		);

		const data = await response.json();

		if (!response.ok) {
			throw new Error(data.error ?? "An error occured");
		}
		return data;
	};

    const uploadToS3 = async (URL: string, file: Blob, contentType: string) => {
		const response = await fetch(URL, {
			method: "PUT",
			headers: {
				"Content-Type": contentType,
			},
			body: file,
		});

		if (!response.ok) {
			throw new Error("An error occured while uploading the file(s)");
		}
	};

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
    
        if (!signatureFile || !digitalSealFile) {
            console.log("Both files are required.");
            return;
        }
    
        try {
            setIsLoading(true)
            // Get the upload URL and fileURL for the signature
            const signatureUploadData = await getSignatureUploadUrl(signatureFileType);
            const signatureFileURL = signatureUploadData?.fileURL;
            console.log(signatureFileURL)
    
            if (signatureUploadData?.uploadURL && signatureFileURL) {
                await uploadToS3(signatureUploadData.uploadURL, signatureFile, signatureFileType);
                console.log("Signature uploaded successfully.");
            } else {
                throw new Error("Signature upload URL or file URL not provided by the server.");
            }
    
            // Get the upload URL and fileURL for the digital seal
            const digitalSealUploadData = await getDigitalSealUploadUrl(digitalSealFileType);
            const digitalSealFileURL = digitalSealUploadData?.fileURL;
    
            if (digitalSealUploadData?.uploadURL && digitalSealFileURL) {
                await uploadToS3(digitalSealUploadData.uploadURL, digitalSealFile, digitalSealFileType);
                console.log("Digital seal uploaded successfully.");
            } else {
                throw new Error("Digital seal upload URL or file URL not provided by the server.");
            }
    
            const digitalSeal = digitalSealFileURL;
            const signature = signatureFileURL
            console.log(digitalSeal)
            console.log(signature)
            const saveResponse = await fetch("https://backend-kyw8.onrender.com/court-records", {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify({
                    applicationId,
                    signature,
                    digitalSeal,
                    applicationReason
                })
            });
            const data = await saveResponse.json()
            console.log(data)
    
            if (!saveResponse.ok) {
                throw new Error("Failed to save file URLs to the backend.");
            }
            localStorage.removeItem('applicationId')
            localStorage.removeItem('caseId')
            console.log(caseId)
            console.log(applicationId)
            setIsLoading(false);
            console.log("Documents was successfully uploaded")
			toast.success("Documents was successfully uploaded", {
				position: "top-center",
			});
            Navigate('/')
		} catch (error) {
			console.error("Error submitting form:", error);
			toast.error("An unexpected error occurred. Please try again later.", {
				position: "bottom-right",
			});
			setIsLoading(false);
		}
	};
    
    
    return (
        <div className="main-div">
             <div className="form-div !max-w-3/4 flex flex-col gap-6 border border-[#222222] rounded-[20px]">
                <h3 className="form-header">Upload Documents</h3>
                <form onSubmit={handleSubmit} className="mt-20 grid grid-cols-1 md:grid-cols-1 gap-10">
                    <div>
                        <label htmlFor="seal">Upload Digital Seal:    </label>
                        <input type="file" onChange={handleDigitalSealUpload} />
                    </div>
                    <div>
                        <label htmlFor="signature">Upload Signature:     </label>
                        <input type="file" onChange={handleSignatureUpload} />
                    </div>
                    <div className="flex flex-col">
                        <label htmlFor="applicationReason">Application Reason:</label>
                        <textarea
                            id="applicationReason"
                            value={applicationReason}
                            className="vc-reg-input"
                            onChange={(e) => setApplicationReason(e.target.value)}
                        />
                    </div>
                    <div className="flex justify-end col-span-full">
                        <Button buttonText="Submit" onClick={handleSubmit} isLoading={isLoading} disabled={isLoading}/>
                    </div>
                </form>
            </div>
        </div>
       
    );
};

export default UploadDocument;
